export default __webpack_public_path__ + "static/media/salzburg.23c6e711.jpg";